import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroDocumentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='NUM. DOCUMENTO' htmlFor='filtro-numeroDocumento' xs={4} xl={5} alignRightAt='xs' />
      <Col xs={8} xl={7}>
        <Field name='numeroDocumento'>
          {({ field }) => <Form.InputNumber {...field} id='filtro-numeroDocumento' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroDocumentoFormGroup)
